/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'
import { useSettingsContext } from '../SettingsProvider'

export type PriceFieldProps = FormNumberFieldProps & { currency?: string }

function PriceField (props: PriceFieldProps) {
  const {
    currency,
    label,
    name = 'price',
    ...others
  } = props
  const intl = useIntl()
  const { settings } = useSettingsContext()
  const suffix = (currency || settings.CURRENCY)
  return (
    <FormNumberField
      label={label || intl.formatMessage({
        id: 'price',
        defaultMessage: 'Prix'
      })}
      name={name}
      parser={parseNumber}
      suffix={suffix != null ? ' ' + suffix : undefined}
      decimalSeparator=","
      thousandSeparator=" "
      {...others}
    />
  )
}

export default PriceField
